<template>
    <div class="footer">
        <div class="container-fluid text-white" style="background: #061429;">
            <div class="container text-center">
                <div class="row justify-content-end">
                    <div class="col-lg-12 col-md-6">
                        <div class="d-flex align-items-center justify-content-center" style="height: 75px;">
                            <p class="mb-0">© <a class="text-white border-bottom" href="https://www.tabnova.com/enterprise-mobility-management" target="_blank">NovaEMM</a>. All Rights Reserved. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>